import dayjs from 'dayjs';
import { Stack } from '@mui/material';
import { BlockState, CampaignRow } from '@retail/dashboard/components';
import { DashboardMessageKey, useDashboardTFunction } from '@retail/dashboard/i18n';
import { CampaignType, MemberCampaignDTO } from '@retail/campaign/types';
import { mgPrisRoutes } from '@retail/mgpris/config';

const campaignTypeMessageMap: Record<CampaignType, DashboardMessageKey> = {
  CENTRAL: 'dashboard.kampanjer.types.CENTRAL',
  OPTIONAL: 'dashboard.kampanjer.types.OPTIONAL',
  SUPPLIER: 'dashboard.kampanjer.types.SUPPLIER',
  LOCAL: 'dashboard.kampanjer.types.LOCAL',
};

interface Props {
  campaigns: MemberCampaignDTO[];
}

export const CampaignsPanel = ({ campaigns }: Props) => {
  const t = useDashboardTFunction();

  if (campaigns.length === 0) {
    return <BlockState>{t('dashboard.messages.noData')}</BlockState>;
  }

  return (
    <Stack gap={0.25}>
      {campaigns.map((campaign) => (
        <CampaignRow
          key={campaign.id}
          name={campaign.campaignName}
          typeLabel={t(campaignTypeMessageMap[campaign.campaignType])}
          dateRange={`${dayjs(campaign.validFrom).format('l')} – ${dayjs(campaign.validTo).format(
            'l'
          )}`}
          enrolled={'isEnrolled' in campaign ? campaign.isEnrolled : undefined}
          enrolledLabel={t('dashboard.kampanjer.enrolled')}
          notEnrolledLabel={t('dashboard.kampanjer.notEnrolled')}
          to={mgPrisRoutes.campaigns.campaignType.campaignDetails.getFullLinkPath({
            campaignId: campaign.id,
            campaignType: campaign.campaignType,
          })}
        />
      ))}
    </Stack>
  );
};
